import React, { Component } from 'react';
import { ElementWrapper, GraphContainer, HalfWrapper, NumbersWrapper, StatsWrapper, Text, TextWrapper, Value } from './StatsElement';
import { Oval } from 'react-loader-spinner';
import { createGraph, statsForProperty } from '../Taula/TaulaUtils';
import { getTranslatedKey } from '../../../../../Utils/TranslateUtils';

export default class StatsComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: '',
      total: '--',
      arith: '--',
      median: '--',
      max: '--',
      min: '--',
      mode: ['--'],
      values: []
    };
  }

  componentDidMount = () => {
    if (this.props.statsValue !== getTranslatedKey('selectAttr')) {
      this.setSelected(this.props.statsValue);
    }
  };

  componentDidUpdate = async (prevProps, prevState) => {
    if (prevProps.layer !== this.props.layer) {
      this.setState({
        total: '--',
        arith: '--',
        median: '--',
        max: '--',
        min: '--',
        mode: ['--'],
        values: [],
        loading: true
      });
    }
    if (prevProps.statsValue !== this.props.statsValue) {
      if (this.props.statsValue !== getTranslatedKey('selectAttr')) {
        this.setSelected(this.props.statsValue);
      }
    }
  };

  setSelected = async (option) => {
    this.setState({ selected: option, loading: true });
    let properties = this.props.layer.getProperties();
    const title = this.props.layer.getTitle();
    let property = properties.find((property) => property.alias === option);
    let { total, arith, median, max, min, mode, values } = await statsForProperty(
      this.props.layer,
      property?.name || option,
      this.props.taulaFullFilter[title]
    );
    this.setState({ total: total, arith: arith, median: median, max: max, min: min, mode: mode, values: values, loading: false });
  };

  render() {
    return (
      <StatsWrapper altura={this.props.alturaInfoPunt}>
        <HalfWrapper>
          <Text>
            {getTranslatedKey('capa')}: <b>{this.props.layer.getTitle()}</b>
            <br />
            {getTranslatedKey('field')}: <b>{this.state.selected}</b>
          </Text>
          {this.state.loading ? (
            <Oval
              height={window.innerHeight > 400 ? 80 : 40}
              width={window.innerHeight > 400 ? 80 : 40}
              color="#febf00"
              wrapperStyle={{ display: 'flex', justifyContent: 'center', margin: '10px' }}
              wrapperClass=""
              visible={true}
              ariaLabel="oval-loading"
              secondaryColor="#ccc"
              strokeWidth={2}
              strokeWidthSecondary={2}
            />
          ) : (
            <NumbersWrapper>
              <TextWrapper>
                <ElementWrapper>
                  <Text title={getTranslatedKey('statsTotal')}>{getTranslatedKey('statsTotal')}:</Text>
                  <Value> {this.state.total}</Value>
                </ElementWrapper>
                <ElementWrapper>
                  <Text
                    style={{ textDecoration: 'underline', textDecorationColor: '#d63ce7', textDecorationThickness: '2px' }}
                    title={getTranslatedKey('statsAritTitle')}>
                    {getTranslatedKey('statsArit')}:
                  </Text>
                  <Value>{this.state.arith}</Value>
                </ElementWrapper>
                <ElementWrapper>
                  <Text
                    style={{ textDecoration: 'underline', textDecorationColor: '#94b651', textDecorationThickness: '2px' }}
                    title={getTranslatedKey('statsMedianTitle')}>
                    {getTranslatedKey('statsMedian')}:
                  </Text>
                  <Value>{this.state.median}</Value>
                </ElementWrapper>
              </TextWrapper>
              <TextWrapper>
                <ElementWrapper>
                  <Text title={getTranslatedKey('statsMaxTitle')}>{getTranslatedKey('statsMax')}</Text>
                  <Value>{this.state.max}</Value>
                </ElementWrapper>
                <ElementWrapper>
                  <Text title={getTranslatedKey('statsMinTitle')}>{getTranslatedKey('statsMin')}:</Text>
                  <Value>{this.state.min}</Value>
                </ElementWrapper>
                <ElementWrapper>
                  <Text
                    style={{ textDecoration: 'underline', textDecorationColor: '#f09400', textDecorationThickness: '2px' }}
                    title={getTranslatedKey('statsModeTitle')}>
                    {getTranslatedKey('statsMode')}:
                  </Text>
                  <Value>{this.state.mode.join(', ')}</Value>
                </ElementWrapper>
              </TextWrapper>
            </NumbersWrapper>
          )}
        </HalfWrapper>
        <HalfWrapper>
          {!this.state.loading && this.state.max !== '--' && (
            <GraphContainer altura={this.props.alturaInfoPunt}>{createGraph(this.state.values, this)}</GraphContainer>
          )}
        </HalfWrapper>
      </StatsWrapper>
    );
  }
}
